import React from 'react';
import { Redirect, useLocation, useHistory } from 'react-router';
import style from './NewPasswordForm.module.scss';
import { Formik, Form } from 'formik';
import { parseQueryString } from '../../../../util';
import { Input, Stack, Heading, Box, Button } from '@chaser/components';
import LabeledFieldWithErrorLabel from '../../../../components/LabeledFieldWithErrorLabel/index';
import * as Yup from 'yup';
import { checkPasswordStrength } from '../../../../util/passwordStrength';
import AuthenticationService from '../../../../services/authentication-service';
import usePush from '../../../../hooks/usePush';
import { toast } from '../../../../components/ToastContainer';
import Logo from '../../../../components/Logo';

const NewPasswordForm = () => {
  const location = useLocation();
  const history = useHistory();
  const { email, token } = parseQueryString(location.search);

  const { execute: executeSetPassword, loading } = usePush(AuthenticationService.setNewPassword, {
    errorToast: true,
  });

  if (!email || !token) {
    return <Redirect to="/recover" />;
  }

  return (
    <Formik
      initialValues={{
        password: '',
      }}
      validationSchema={Yup.object().shape({
        password: Yup.string()
          .required('You must set a password')
          .max(100)
          .test(
            'checkPasswordStrength',
            'Password too weak. Try making it longer, or adding uppercase letters, symbols or numbers.',
            checkPasswordStrength(3, 10),
          ),
      })}
      validateOnBlur={false}
      enableReinitialize
      onSubmit={async ({ password }, actions) => {
        await executeSetPassword(email, token, password);
        actions.setSubmitting(false);
        actions.resetForm();

        history.push('/login');
        toast.success('You can now log in with your new password');
      }}
    >
      {({ values, isValid }) => (
        <Form>
          <div className={style.formCard}>
            <div className={style.loginFormHead}>
              <Logo />
            </div>
            <Box p="large">
              <Stack gap="large" alignItems="center" flexDirection="column" display="flex">
                <Heading as="h2">Choose password</Heading>
                <Stack>
                  <LabeledFieldWithErrorLabel
                    name="password"
                    as={Input}
                    icon="lock"
                    id="password"
                    placeholder="Enter password"
                    type="password"
                    autocomplete="off"
                  />
                  <Button
                    loading={loading}
                    disabled={!values.password || !isValid}
                    style={{ width: '100%' }}
                    type="submit"
                  >
                    Set password
                  </Button>
                </Stack>
              </Stack>
            </Box>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default NewPasswordForm;
